import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { refreshToken } from '../auth/handleTokens';
import useAuth from '../auth/useAuth';
import { constants } from '../constants';

export default function Content(props) {

  const toggle = props.toggleSidebar ? '215px' : '10px'
  const {user} = useAuth();
  const {name}= user;
  const width = props.width
  const display = width > 995 ? 'flex' : 'inherit'
  const [messages, setMessages] = useState(0);
  const [contacts, setContacts] = useState(0);
  const [credits, setCredits] = useState(0);
  
  const getMessages = async() => {
    try {
      const URL = constants.test_host + '/sms/count-messages';
      const token = window.localStorage.getItem('at');
      const {data}= await axios.get(URL, {headers: {
        'Authorization': `Bearer ${token}`
      },withCredentials: true})
      setMessages(data.count)
      
    } catch (error) {
      console.log(error.response.data);
      if(error.response.data.statusCode ===401){
          const result= await refreshToken();
          if(result) getMessages();
          else return window.location.href= '/login';
        } else {
          window.localStorage.clear();
          return window.location.href = '/login;'
        }
    }
  }

  const getContacts = async() => {
    try {
      const URL = constants.test_host + '/user/count/contacts';
      const token = window.localStorage.getItem('at');
      const {data}= await axios.get(URL, {headers: {
        'Authorization': `Bearer ${token}`
      },withCredentials: true})
      setContacts(data.count)
      
    } catch (error) {
      console.log(error.response.data);
      if(error.response.data.statusCode ===401){
        const result= await refreshToken();
        if(result) getContacts();
        else return window.location.href= '/login';
      } else {
        window.localStorage.clear();
        return window.location.href = '/login;'
      }
    }
  }

  const getData = async() => {
    getMessages();
    getContacts();
    getCredits();
  }
  
    useEffect(()=> {
      getData();
    },[])

  const getCredits = async() => {
    try {
      const URL = constants.test_host + '/user/count/credits';
      const token = window.localStorage.getItem('at');
      const {data}= await axios.get(URL, {headers: {
        'Authorization': `Bearer ${token}`
      },withCredentials: true})
      setCredits(data.count)
      
    } catch (error) {
      if(error.response.data.statusCode ===401){
        const result= await refreshToken();
        if(result) getCredits();
        else return window.location.href= '/login';
      } else {
        window.localStorage.clear();
        return window.location.href = '/login;'
      }
    }
  }


  return (
    <div
      className="content-wrapper content"
      style={{ marginLeft: `${toggle}`, transition: "all 0.5s" }}
    >
      <span className='text-primary font-weight-bold'><strong>Hola {name},</strong></span>
      <div className='cards-dashboard' style={{display: `${display}`}}>
        <div className="col-xl-3 col-md-6 mb-4 col-content">
          <div className="card border-left-warning shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-warning text-uppercase mb-1">
                    Mensajes Enviados
                  </div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800"><span>{messages}</span></div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-comments fa-2x text-gray-300" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4 col-content">
          <div className="card border-left-primary shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                    Contactos
                  </div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800"><span>{contacts}</span></div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-users fa-2x text-gray-300" />
                </div>
              </div> 
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4 col-content">
          <div className="card border-left-success shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                    Créditos
                  </div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800"><span>{credits}</span></div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-coins fa-2x text-gray-300" />
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  );
}
